/**
 * SEO "Tech Stack": looping card slider with arrows hidden when everything fits.
 */
document.addEventListener('DOMContentLoaded', function () {
    var section = document.querySelector('.seo-tech-stack-section');
    if (!section) return;
    var track = section.querySelector('.seo-tech-stack-track');
    var cards = section.querySelectorAll('.seo-stack-card');
    var arrowsContainer = section.querySelector('.header-right-arrows');
    var prevBtn = section.querySelector('.arrow-prev');
    var nextBtn = section.querySelector('.arrow-next');

    if (!track || !cards.length || !arrowsContainer || !prevBtn || !nextBtn) return;

    var currentIndex = 0;

    function checkArrowVisibility() {
        // Desktop shows 4 cards at once, mobile shows 1
        var visible = window.innerWidth > 991 ? 4 : 1;
        arrowsContainer.style.display = cards.length <= visible ? 'none' : 'flex';
    }

    function updateSlider() {
        checkArrowVisibility();
        var cardWidth = cards[0].offsetWidth + 24; // width + gap
        track.style.transform = 'translateX(-' + (currentIndex * cardWidth) + 'px)';
    }

    nextBtn.addEventListener('click', function () {
        currentIndex = currentIndex < cards.length - 1 ? currentIndex + 1 : 0;
        updateSlider();
    });

    prevBtn.addEventListener('click', function () {
        currentIndex = currentIndex > 0 ? currentIndex - 1 : cards.length - 1;
        updateSlider();
    });

    window.addEventListener('resize', updateSlider);
    checkArrowVisibility();
});
